/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useRef, useState } from 'react';
import MainLayout from '../Layouts/Mainlayout';
import {
    TextField,
    Autocomplete,
    FormControl,
    InputAdornment,
    IconButton
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
//@ts-ignore
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from 'moment';
import { HugeiconsIcon } from '@hugeicons/react';
// @ts-ignore
import { ArrowDown01Icon, Download04Icon, Cancel01Icon } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { exportBounceReport } from 'src/services/reportService';
import CsvService from 'src/services/dataExport.service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
// import { useLocation } from 'react-router-dom';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import type { TableColumn } from 'react-data-table-component';
import { getAllCampaigns,getAllBulkCampaigns } from 'src/services/campaignService';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import MUIModal from '../MUIModal/MUIModal';
import BounceReason from './BounceReason';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';
import { BOUNCEREPORT_CAMPAIGN_DISABLED_MESSAGE } from 'src/constants/constant'
import { useLocation } from 'react-router-dom';

interface FormValues {
    clientId: number;
    campaignType: string;
    campaingId?: number;
    startDate: string;
    endDate: string;
}

interface BillingReportData {
    campaignName: string;
    email: string;
    eventTime: string;
    firstName: string;
    lastName: string;
    npi: string;
    reason: string;
}

const BounceReport: React.FC = (): JSX.Element => {
    const location = useLocation();
    const state = location.state as { start?: Date; end?: Date } | null;
    const today = new Date();
    const defaultStart = new Date();
    defaultStart.setDate(today.getDate());
    const { start = defaultStart } = state ?? {};
    const end = today;
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [clientId, setClientId] = useState<number>(0);
    // const ninetyDaysAgo = new Date();
    // ninetyDaysAgo.setDate(today.getDate());
    const dateRangeRef: any = useRef(null);
    const [isDateRangeOpen, setIsDateRangeOpen] = useState<boolean>(false)
    const [fromDate, setFromDate] = useState<any>(start)
    const [endDate, setEndDate] = useState<any>(end)
    const [reportDateRange, setReportDateRange] = useState<any>()
    const [reportData, setReportData] = useState<any>([])
    // const [totalSentCount, setTotalSentCount] = useState<number>(0);
    const [openBounceReasonModal, setOpenBounceReasonModal] = useState<boolean>(false)
    const [selectedBounceData, setSelectedBounceData] = useState<BillingReportData | null>(null);
    const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
    const [campaignType, setCampaignType] = useState<string>('campaign');
    const { user} = useSelector((state: RootState) => state.auth);
    const [isCampaignLoading, setIsCampaignLoading] = useState<boolean>(false);

    const [campaigns, setCampaigns] = useState<any[]>([]);


    const {
        control,
        handleSubmit,
        // reset,
        setValue,
    } = useForm<FormValues>({
        defaultValues: {
            campaignType: 'campaign',
          startDate: moment(start).format('YYYY-MM-DD'),
          endDate: moment(end).format('YYYY-MM-DD'), 
        },
        mode: 'onChange' // This will validate on every change
    });

  useEffect((): void => {
    console.log('User from Redux:', user);
        const clientId = Number(user?.clientId ?? 0);
     setClientId(clientId);
    handleCampaignList({value: 'campaign', label: 'Trigger Email'})
    getReportData();

    }, [user]);

    const getReportData = (): void => {
        const formattedStartDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
        const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : '';


        setIsDataLoading(true);
        exportBounceReport(clientId,campaignType, 0, formattedStartDate, formattedEndDate)
            .then((res: any) => {
                setIsDataLoading(false);
                if (res.status === 200) {
                    console.log(res)
                    if (res.data.result === 1) {
                        const reportData = res.data.data;
                        if (reportData.length > 0) {
                            setReportData(reportData);
                        } else {
                            setReportData([]);
                            NotificationManager.error('No data available', '', 5000);
                        }
                    } else {
                        setReportData([]);
                        NotificationManager.error('No data available', '', 5000);
                    }
                }
            }).finally(() => {
                setIsDataLoading(false);
            })
    }


    const onSubmit = async (data: FormValues): Promise<void> => {

        if (!campaignType) {
            NotificationManager.error(BOUNCEREPORT_CAMPAIGN_DISABLED_MESSAGE, '', 5000);
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { campaingId } = data;

        // Format dates to YYYY-MM-DD format for API
        const formattedStartDate = fromDate ? moment(fromDate).format('YYYY-MM-DD') : '';
        const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : '';


        setIsDataLoading(true);
        exportBounceReport(clientId,campaignType, campaingId, formattedStartDate, formattedEndDate)
            .then((res: any) => {
                setIsDataLoading(false);
                if (res.status === 200) {
                    console.log(res)
                    if (res.data.result === 1) {
                        const reportData = res.data.data;
                        // const total = res.data.data.total;
                        if (reportData.length > 0) {
                            setReportData(reportData);
                            // setTotalSentCount(total);
                        } else {
                            setReportData([]);
                            NotificationManager.error('No data available', '', 5000);
                        }
                    } else {
                        setReportData([]);
                        NotificationManager.error('No data available', '', 5000);
                    }
                }
            }).finally(() => {
                setIsDataLoading(false);
            })
    }

    const handleExportReport = (): void => {
        const data: any = [];
        if (reportData.length > 0) {
            reportData.map((item: any) => {
                const newItem = {
                    "NPI": item.npi,
                    "First Name": item.firstName,
                    "Last Name": item.lastName,
                    "Email": item.email,
                    "Campaign": item.campaignName,
                    "Reason": item.reason,
                    "Created On": moment(item.eventTime).format("MM-DD-YYYY HH:mm:ss")
                }
                data.push(newItem)
            })
            const clientName = user?.selectedClientName ? user.selectedClientName.replaceAll(' ', '_') : 'Client';
            CsvService.downloadXlsFile(data, `${clientName}_Bounce_Report.xlsx`);
        } else {
            NotificationManager.error('No data available for download', '', 5000);
        }
    }

    const handleDateRangeClick = (ranges: any): void => {

        const selectedStart = ranges.selection.startDate;
        const selectedEnd = ranges.selection.endDate;

        setReportDateRange({
            startDate: selectedStart,
            endDate: selectedEnd,
            key: 'selection'
        });

        if (selectedStart !== selectedEnd) {
            setFromDate(selectedStart);
            setEndDate(selectedEnd);

            // Update form values and trigger validation
            const startDateString = moment(selectedStart).format('YYYY-MM-DD');
            const endDateString = moment(selectedEnd).format('YYYY-MM-DD');

            setValue('startDate', startDateString, { shouldValidate: true });
            setValue('endDate', endDateString, { shouldValidate: true });

            console.log('Updated form dates:', startDateString, endDateString);

            setTimeout(() => {
                setIsDateRangeOpen(false);
            }, 500);
        }
    };

    const handleDateChange = (): void => {
        setIsDateRangeOpen(true)
        setReportDateRange({
            startDate: fromDate ?? new Date(),
            endDate: endDate  ?? new Date(),
            key: 'selection'
        })
    }

    const getDateRangeDisplayValue = (): string => {
    if (fromDate && endDate) {
        return `${moment(fromDate).format('MM/DD/YYYY')} - ${moment(endDate).format('MM/DD/YYYY')}`;
    }
    return '';
    };

    const handleClearDateRange = (): void => {
        setFromDate(null);
        setEndDate(null);
        setReportDateRange(null);
    };

    // Initialize date range on component mount
    useEffect(() => {
        setReportDateRange({
            startDate: fromDate,
            endDate: endDate,
            key: 'selection'
        });
    }, [fromDate, endDate]);

    // useEffect(() => {
    //     getAllCampaignsByClientId(clientId);
    // }, [clientId]);

    const handleRefreshPage = (): void => {
        handleCloseBounceReasonModal()
    }

    const handleCloseBounceReasonModal = (): void => {
        setOpenBounceReasonModal(false)
    }

    const handleBounceReason = (data: BillingReportData): void => {
        setSelectedBounceData(data);
        setOpenBounceReasonModal(true);
        setAnchorActionEl(null);
        if (data.npi) {
        setAnchorActionEl({
            ...anchorActionEl,
            [data.npi]: null
        });
    }
    }

    const columns: TableColumn<BillingReportData>[] = [
        {
            name: 'NPI',
            selector: (row: BillingReportData) => row.npi ?? 0,
            width: '10%',
            wrap: true,
            sortable: true,
        },
        {
            name: 'First Name',
            selector: (row: BillingReportData) => row.firstName,
            width: '12%',
            wrap: true,
            sortable: true
        },
        {
            name: 'Last Name',
            selector: (row: BillingReportData) => row.lastName,
            width: '12%',
            wrap: true,
            sortable: true
        },
        {
            name: 'Email',
            selector: (row: BillingReportData) => row.email,
            width: '18%',
            wrap: true,
            sortable: true,
            cell: (row: BillingReportData) => (
                <div
                    title={row.email}
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%'
                    }}onClick={() => handleBounceReason(row)}
                >
                    {row.email}
                </div>
            )
        },
        {
            name: 'Campaign Name',
            selector: (row: BillingReportData) => row.campaignName,
            width: '20%',
            wrap: true,
            sortable: true,
            cell: (row: BillingReportData) => (
                <div
                    title={row.campaignName}
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%'
                    }}
                    onClick={() => handleBounceReason(row)}
                >
                    {row.campaignName}
                </div>
            )
        },
        {
            name: 'Reason',
            selector: (row: BillingReportData) => row.reason,
            width: '180px',
            cell: (row: any) => {
                return (
                    <div className="flex items-center justify-between first:pt-0 last:pb-0" style={{ width: '100%' }}>
                        <div className="overflow-hidden text-ellipsis whitespace-nowrap text-14 text-muted"  style={{ width: 'calc(100% - 30px)' }}>
                            <CustomTooltip title={row.reason} placement="bottom" arrow={false}>
                                <p className="overflow-hidden text-ellipsis whitespace-nowrap w-full cursor-pointer" onClick={() => handleBounceReason(row)}>{row.reason} </p>
                            </CustomTooltip>
                        </div>
                    </div>
                );
            }
        },
        {
            name: 'Created',
            selector: (row: BillingReportData) => moment(row.eventTime).format("MM/DD/YYYY"),
            width: '12%',
            wrap: true,
            cell: (row: BillingReportData) => (
                <div title={moment(row.eventTime).format("MM/DD/YYYY")} onClick={() => handleBounceReason(row)}>
                    {moment(row.eventTime).format("MM/DD/YYYY")}
                </div>
            )
        },

    ];
  const options = [    
    { value: 'campaign', label: 'Trigger Email' },
    { value: 'bulkemail', label: 'Bulk Email' }
  ];

  const handleCampaignList = (newValue: any): void => {  
  setIsCampaignLoading(true);
  if (newValue) {
    console.log(newValue);
    const selectedType = newValue.value;
    setCampaignType(selectedType);
    
    // Reset campaign selection when type changes
    setValue('campaingId', 0);
    setCampaigns([]);
    
    // Fetch campaigns based on selected type
    if (selectedType === 'campaign') {
      // Call getAllCampaigns for Trigger Email
      getAllCampaigns(clientId)
        .then((res: any) => {
          if (res.status === 200 && res.data.result === 1 && Array.isArray(res.data.data)) {
            // Normalize trigger campaigns to have consistent properties
            const normalizedCampaigns = res.data.data.map((campaign: any) => ({
              campaignId: campaign.campaignId,
              name: campaign.name,
              brandName: campaign.brandName,
              sent: campaign.sent,
              open: campaign.open,
              clicks: campaign.clicks
            }));
            setIsCampaignLoading(false);
            setCampaigns(normalizedCampaigns);
          } else {
            setIsCampaignLoading(false);
            setCampaigns([]);
          }
        })
        .catch((error) => {
            setIsDataLoading(false);
          console.error('Error fetching trigger campaigns:', error);
          setCampaigns([]);
        });
    } else if (selectedType === 'bulkemail') {
      // Call getAllBulkCampaigns for Bulk Email
      getAllBulkCampaigns(clientId)
        .then((res: any) => {
          if (res.status === 200 && res.data.result === 1 && Array.isArray(res.data.data)) {
            // Normalize bulk campaigns to have consistent properties
            const normalizedCampaigns = res.data.data.map((campaign: any) => ({
              campaignId: campaign.bulkCampaignId,
              name: campaign.bulkCampaignName,
              templateName: campaign.templateName,
              sent: campaign.sent,
              open: campaign.open,
              clicks: campaign.clicks
            }));
            setIsCampaignLoading(false);
            setCampaigns(normalizedCampaigns);
          } else {
            setIsCampaignLoading(false);
            setCampaigns([]);
          }
        })
        .catch((error) => {
            setIsDataLoading(false);
            setIsCampaignLoading(false);
          console.error('Error fetching bulk campaigns:', error);
          setCampaigns([]);
        });
    }
  } else {
    // If no value selected, reset everything
    setIsDataLoading(false);
    setIsCampaignLoading(false);
    setCampaignType('');
    setCampaigns([]);
    setValue('campaingId', 0);
  }
};
    return (
        <div className="flex flex-row justify-start">
            <MainLayout>
                <>
                    <h2 className="text-2xl font-semibold text-title">Bounce Reports</h2>
                    <div className="mt-[20px] mb-[20px] live-outreach-container">
                        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-5">
                          
                            <div className="w-full lg:w-auto">
                                 <FormControl fullWidth>
                                              <Autocomplete
                                                options={options}
                                                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                                                getOptionLabel={(option) => option.label}
                                                popupIcon={
                                                  <HugeiconsIcon
                                                    icon={ArrowDown01Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                
                                                  />
                                                }
                                                onChange={(event, newValue) => handleCampaignList(newValue)}
                                                value={options.find(opt => opt.value === campaignType) ?? null}
                                                // disableClearable
                                                // isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                renderInput={(params) => (
                                                  <TextField
                                                    label="Campaign Type"
                                                    {...params}
                                                    placeholder="Select Campaign Type"
                                                    variant="outlined"
                                                    sx={{
                                                      '& .MuiOutlinedInput-root': {
                                                        borderRadius: '40px',
                                                        height: '40px',
                                                        width: '205px', // Increased width
                                                      },
                                                    }}
                                                  />
                                                )}
                                                sx={{
                                                  '& .MuiAutocomplete-clearIndicator': {
                                                    marginRight: '-12px'
                                                  },
                                                  '& .MuiAutocomplete-input': {
                                                    width: '70%'
                                                  }
                                                }}
                                              //disableClearable
                                              />
                                            </FormControl>
                            </div>
                            {/* Campaign Selection Field */}
                           <div className="w-full lg:w-auto">                         
                                <CustomTooltip title={ campaignType == "" && !isCampaignLoading ? BOUNCEREPORT_CAMPAIGN_DISABLED_MESSAGE : ""}>
                                <FormControl fullWidth>
                                <Controller
                                    name="campaingId"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                    <Autocomplete
                                        options={campaigns}
                                        disabled={campaignType == "" || isCampaignLoading}
                                        loading={isCampaignLoading}
                                        getOptionLabel={(option: any) => {
                                        if (!option) return '';
                                        // Display name based on campaign type
                                        const displayName = option.name || '';
                                        return displayName;
                                        }}
                                        popupIcon={
                                        isCampaignLoading ? (
                                            <span className="loading loading-spinner loading-sm text-gray-400"></span>
                                        ) : (
                                            <HugeiconsIcon
                                            icon={ArrowDown01Icon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.5}
                                            />
                                        )
                                        }
                                        isOptionEqualToValue={(option, value) => option?.campaignId === value}
                                        value={campaigns.find((c) => c.campaignId === field.value) || null}
                                        onChange={(_, selectedClient) => {
                                        const id = selectedClient?.campaignId ?? 0;
                                        field.onChange(id);
                                        }}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Campaign"
                                            placeholder="Select Campaign"
                                            error={fieldState.invalid}
                                            helperText={
                                            fieldState.error && (
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <img
                                                    src="/assets/images/attention.svg"
                                                    alt="error"
                                                    width={14}
                                                    height={14}
                                                />
                                                {fieldState.error.message}
                                                </span>
                                            )
                                            }
                                            autoComplete="off"
                                            fullWidth
                                            sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '40px',
                                                height: '40px',
                                                width: '200px',
                                            },
                                            }}
                                        />
                                        )}
                                        sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                        }}
                                    />
                                    )}
                                />
                                </FormControl>
                                </CustomTooltip>
                            </div>

                            {/* Date Range Field */}
                            <div className="w-full lg:w-auto">
                                <FormControl>
                                    <TextField
                                    id="date-range"
                                    label="Date Range"
                                    variant="outlined"
                                    autoComplete='off'
                                    ref={dateRangeRef}
                                    InputProps={{
                                        endAdornment: (
                                        <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                            {getDateRangeDisplayValue() && (
                                            <IconButton 
                                                onClick={handleClearDateRange}
                                                size="small"
                                                sx={{ marginRight: '4px' }}
                                            >
                                                <HugeiconsIcon
                                                    icon={Cancel01Icon}
                                                    size={16}
                                                    color="#666"
                                                    strokeWidth={0.5}
                                                />
                                            </IconButton>
                                            )}
                                            <HugeiconsIcon
                                                icon={Calendar03Icon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.5}
                                                onClick={handleDateChange}
                                            />
                                        </InputAdornment>
                                        )
                                    }}
                                    onChange={handleDateChange}
                                    onFocus={handleDateChange}
                                    value={getDateRangeDisplayValue()}
                                    placeholder="Select date range"
                                    sx={{
                                        width: { xs: '100%', sm: '225px', md: '225px', lg: '225px' },
                                        minWidth: '270px',
                                        '& .MuiOutlinedInput-root': {
                                        height: '56px',
                                        '& .MuiOutlinedInput-input': {
                                            padding: '16px 14px',
                                            height: 'auto',
                                            lineHeight: '1.4375em',
                                        },
                                        },
                                        '& .MuiInputLabel-root': {
                                        padding: '0 4px',
                                        fontSize: '13px',           
                                        lineHeight: '1.2',
                                        },
                                    }}
                                    />
                                    {isDateRangeOpen && (
                                    <div ref={dateRangeRef} style={{ position: 'absolute', zIndex: '999', top: '100%', marginTop: '4px' }}>
                                        <DateRangePicker
                                        ranges={reportDateRange ? [reportDateRange] : []} 
                                        onChange={handleDateRangeClick}
                                        dateDisplayFormat={'MM/dd/yyyy'}
                                        inputRanges={[]}
                                        color={"#FFF5F6"}
                                        rangeColors={["#D6242C"]}
                                        editableDateInputs={true}
                                        startDatePlaceholder={"MM/DD/YYYY"}
                                        endDatePlaceholder={"MM/DD/YYYY"}
                                        />
                                    </div>
                                    )}
                                </FormControl>
                            </div>

                            {/* Buttons Section */}
                            <div className="flex flex-wrap gap-2 sm:gap-3 lg:gap-2 w-full lg:mt-2">
                                {/* <div className="w-full sm:w-auto">
                                    <OutlineButton
                                        color="gray"
                                        onClick={handleReset}
                                        disabled={isDataLoading}
                                        width="120px"
                                    >
                                        Reset
                                    </OutlineButton>
                                </div> */}

                                <div className="w-full sm:w-auto">
                                    <GradientButton
                                        type="submit"
                                        color="red"
                                        disabled={isDataLoading}
                                        width="120px"
                                        onClick={() => void handleSubmit(onSubmit)()}
                                    >
                                        {!isDataLoading ? 'Submit' : (
                                            <span className="loading loading-spinner loading-xs text-white"></span>
                                        )}
                                    </GradientButton>
                                </div>
                                {reportData.length > 0 &&
                                    <div className="w-full sm:w-auto">
                                        <OutlineButton
                                            onClick={handleExportReport}
                                            type="rounded"
                                            color="gray"
                                            width="120px"
                                        >
                                            <HugeiconsIcon
                                                icon={Download04Icon}
                                                size={20}
                                                color="#3a3a3a"
                                                stroke="0.2"
                                            />
                                            <span className="ml-[5px]">Download</span>
                                        </OutlineButton>
                                    </div>
                                }
                            </div>
                        </form>


                    </div>
                    <div className='data-table-container te-table-container mb-10'>
                        <CustomDataTable
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            columns={columns}
                            data={reportData}
                            pagination
                            responsive
                            //   selectableRows
                            progressPending={isDataLoading}
                            onRowClicked={(row) => handleBounceReason(row)}
                            customStyles={{
                                rows: {
                                    style: {
                                        cursor: 'pointer',
                                    },
                                },
                            }}
                        />
                    </div>
                </>
                {selectedBounceData && (
                    <MUIModal title='Bounce Details' openModal={openBounceReasonModal} closeModal={handleCloseBounceReasonModal} width={'50%'} >
                        <BounceReason closeModal={handleCloseBounceReasonModal} refreshPage={handleRefreshPage} data={selectedBounceData} />
                    </MUIModal>
                )}
            </MainLayout>
        </div>
    );
};

export default BounceReport;